import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function CTASection() {
  const sectionRef = useScrollReveal<HTMLElement>({ threshold: 0.2, selector: ".scroll-reveal", staggerDelay: 120 });

  return (
    <section ref={sectionRef} className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800" />
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20geometric%20corporate%20background%20with%20soft%20flowing%20wave%20gradients%2C%20deep%20petroleum%20blue%20and%20teal%20tones%20with%20subtle%20warm%20orange%20highlights%2C%20clean%20minimalist%20design%2C%20professional%20SaaS%20aesthetic%2C%20matte%20finish%2C%20no%20text%2C%20smooth%20organic%20shapes%2C%20modern%20tech%20atmosphere%2C%20editorial%20quality%2C%20dark%20elegant%20ambient%20mood%20with%20soft%20light%20elements%2C%20educational%20technology%20theme&width=1600&height=600&seq=cta-convivencia-v28&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-primary-900/60 to-transparent" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="scroll-reveal flex items-center justify-center gap-2 mb-4">
          <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center">
            <i className="ri-shield-star-line text-white text-lg" />
          </div>
        </div>
        <h2 className="scroll-reveal text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
          Transforma la convivencia escolar de tu colegio hoy
        </h2>
        <p className="scroll-reveal text-lg text-white/70 leading-relaxed mt-4 max-w-2xl mx-auto">
          Únete a más de 50 colegios que ya gestionan sus casos, protocolos e intervenciones con inteligencia artificial. Solicita una demo personalizada para tu equipo.
        </p>

        <div className="scroll-reveal flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); document.querySelector("#hero button")?.dispatchEvent(new MouseEvent("click", { bubbles: true })); }}
            className="px-7 py-4 bg-white text-primary-700 text-sm font-bold rounded-2xl hover:bg-white/90 active:scale-[0.98] transition-all duration-300 shadow-soft-lg cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-calendar-check-line" />
            Solicitar demo
          </a>
          <a
            href="/login"
            className="px-7 py-4 bg-white/10 backdrop-blur-sm border border-white/25 text-white text-sm font-semibold rounded-2xl hover:bg-white/15 active:scale-[0.98] transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-login-box-line" />
            Iniciar sesión
          </a>
        </div>
      </div>
    </section>
  );
}